import { Component, OnInit, Input } from '@angular/core';
import { ProductDto } from '../../typewriter/output/ProductDto';
import { ImageDto } from '../../typewriter/output/ImageDto';
import { ProductOptionDto } from '../../typewriter/output/ProductOptionDto';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

  @Input() product: ProductDto;
  @Input() images: ImageDto[];
  @Input() image: ImageDto;

  selectedOption: ProductOptionDto;
  selectedImages: ImageDto[] = [null, null, null, null];
  uploadedFiles: string[] = [null, null, null, null];

  constructor() { }

  ngOnInit() {
    if (this.product.options.length > 1) {
      let defaultOption = this.product.options.find(o => o.isDefault);
      this.selectedOption = defaultOption;
    }
    else {
      this.selectedOption = this.product.options[0];
    }
  }

  selectedOptionChange(id: number) {
    this.selectedOption = this.product.options.find(o => o.id == id)
    this.selectedImages = [null, null, null, null];
    this.uploadedFiles = [null, null, null, null];
  }

  selectedImageChange(index: number, imageId: number) {
    if (!this.product.allowDuplicateImageIds) {
      let ix = this.selectedImages.findIndex(s => s !== null && s.id == imageId);
      if (ix != -1) {
        this.selectedImages[ix] = null;
      }
    }
    this.selectedImages[index] = this.images.find(i => i.id == imageId);
  }

  imageSummary() {
    if (this.selectedOption) {
      let selections = this.selectedOption.prompts.map((p, i) => this.selectedImages[i] ? `${this.selectedImages[i].name}${p.shortName ? '@' + p.shortName : ''}` : null);
      if (!selections.filter(s => s == null).length) {
        let summary = selections.join(', ');
        return summary;
      }
    }
    return '';
  }

  uploadSummary() {
    if (this.selectedOption) {
      let files = this.selectedOption.prompts.map((p, i) => this.uploadedFiles[i] ? `${p.shortName ? p.shortName + '=' : ''}${this.uploadedFiles[i]}` : null);
      if (!files.filter(s => s == null).length) {
        let summary = files.join(', ');
        return summary;
      }
    }
    return '';
  }

  fileUploaded(file: string, index: number) {
    this.uploadedFiles[index] = file;
  }

  canAddToCart() {
    if (!this.selectedOption) {
      return false;
    }
    else if (this.product.requiresImageSelection) {
      if (this.selectedImages.filter(s => s !== null).length != this.selectedOption.prompts.length) {
        return false;
      }
    }
    else if (this.product.requiresUpload) {
      if (this.uploadedFiles.filter(s => s !== null).length != this.selectedOption.prompts.length) {
        return false;
      }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/product/product.component.ts